
import { Voni } from '../client';

export interface Appointment {
  id: number;
  project_id: number;
  conversation_id?: number;
  customer_name: string;
  customer_email: string;
  customer_phone?: string;
  service_type?: string;
  start_time: string;
  end_time?: string;
  status: string;
  notes?: string;
  created_at: string;
  updated_at: string;
}

export interface AppointmentUpdateInput {
  customer_name?: string;
  customer_email?: string;
  customer_phone?: string;
  service_type?: string;
  start_time?: string;
  end_time?: string;
  status?: string;
  notes?: string;
}

export interface AppointmentListParams {
  skip?: number;
  limit?: number;
  [key: string]: unknown;
}

export class AppointmentResource {
  constructor(private client: Voni) {}

  async list(projectId: number, params?: AppointmentListParams): Promise<Appointment[]> {
    return this.client.request<Appointment[]>('GET', `/projects/${projectId}/appointments`, params);
  }

  async get(projectId: number, appointmentId: number): Promise<Appointment> {
    return this.client.request<Appointment>('GET', `/projects/${projectId}/appointments/${appointmentId}`);
  }

  async update(projectId: number, appointmentId: number, updates: AppointmentUpdateInput): Promise<Appointment> {
    return this.client.request<Appointment>('PUT', `/projects/${projectId}/appointments/${appointmentId}`, undefined, updates);
  }

  async delete(projectId: number, appointmentId: number): Promise<boolean> {
    await this.client.request('DELETE', `/projects/${projectId}/appointments/${appointmentId}`);
    return true;
  }
}
